import React from 'react';
import StatusDot from '../status/StatusDot';

const STATUS_TO_TOKEN = {
  connected: 'running',
  degraded: 'queued',
  offline: 'failed',
  error: 'failed'
};

const STATUS_LABELS = {
  connected: 'Connected',
  degraded: 'Degraded',
  offline: 'Offline',
  error: 'Error'
};

function ConnectionStatusBadge({ status, className = '' }) {
  const tokenKey = STATUS_TO_TOKEN[status] ?? 'idle';

  return (
    <span className={`connection-badge connection-badge--${status} ${className}`.trim()}>
      <StatusDot status={tokenKey} pulse={status === 'connected'} />
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}

export default ConnectionStatusBadge;
